<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="组织名称" prop="name">
      <a-input v-model="form.data.name"/>
    </a-form-model-item>
    <a-form-model-item label="上层组织" prop="parentId">
      <a-cascader
        :props="{ checkStrictly: true }"
        v-model="form.data.parentId"
        :options="organization.tree"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!organizationId" @click="onAdd">{{ $t('CREATE') || '创建' }}</a-button>
        <a-button type="primary" v-if="organizationId" @click="onUpdate">{{ $t('UPDATE') || '更新' }}</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _addOrganization,
  _queryOrganization,
  _queryOrganizations,
  _updateOrganization,
} from '@/api/sys/sysOrganizationApi';

function treeGenerator(x, data, ignoreId) {
  const children = data
    .filter(child => child.value !== ignoreId && child.parentId === x.value)
    .map(child => treeGenerator(child, data));
  return {
    ...x,
    value: x.id,
    label: x.name,
    children,
  };
}

function getTreeNodeParent(x, data) {
  if (!x) {
    return [];
  }
  const parent = data.filter(child => child.value === x);
  if (parent[0]) {
    return [...getTreeNodeParent(parent[0].parentId, data), x];
  }
  return [x];
}


async function getOrganizations() {
  const {content} = await _queryOrganizations({});
  content.map(x => ({
    value: x.id,
    label: x.name,
    parentId: x.parentId,
  }));
  this.organization.data = content;
  this.organization.tree = [
    {
      value: null,
      label: '根节点',
      children: content
        .filter(x => !x.parentId && x.value !== this.organizationId)
        .map(x => treeGenerator(x, content, this.organizationId)),
    },
  ];
}

async function getOrganization() {
  // this.getOrganizations();
  const result = await _queryOrganization(this.organizationId);
  if (result) {
    this.form.data.name = result.name;
    this.form.data.parentId = [null, ...getTreeNodeParent(
      result.parentId,
      this.organization.data,
    )];
  }
}

async function onAdd() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addOrganization({
        name: this.form.data.name,
        parentId: this.form.data.parentId.length > 0
          ? this.form.data.parentId[this.form.data.parentId.length - 1] : null,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

async function onUpdate() {
  this.form.disabled = true;
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateOrganization(this.organizationId, {
        name: this.form.data.name,
        parentId: this.form.data.parentId.length > 0
          ? this.form.data.parentId[this.form.data.parentId.length - 1] : null,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          if (this.onSubmitHandler) {
            this.onSubmitHandler();
          }
        }
      }
    } else {
      this.form.disabled = false;
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'OrganizationEdit',
  props: {
    organizationId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    organizationId(val) {
      this.getOrganizations();
      this.form.data = {
        name: '',
        parentId: [null],
      };
      if (val) {
        this.getOrganization();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getOrganization,
    getOrganizations,
  },
  data() {
    return {
      organization: {
        data: [],
        tree: [],
      },
      form: {
        data: {
          name: '',
          parentId: [null],
        },
        rules: {
          name: [{
            required: true,
            message: '请输入组织名称',
            trigger: 'blur'
          }],
          parentId: [{
            required: false,
            message: 'please choose parentId',
            trigger: 'blur'
          }],
        },
        disabled: false,
        title: '',
      },
    };
  },
  created() {
    this.getOrganizations();
    if (this.organizationId) {
      this.getOrganization();
    }
  },
};
</script>
